module.exports = __webpack_public_path__ + "media/applicants/android-fceed139.png";